import React from "react";
import "./App.css";
import DictionarySearch from './DictionarySearch'; 



function App() {
  return (
    <div className="App">
      <header className="App-header">
        <DictionarySearch />{" "}
        {}
      </header>
    </div>
  );
}

export default App;
